module.exports = {
	"__config__": {
		"name": "ui-theme",
		"resources": [
			"./bottom_left_border.png",
			"./bottom_middle_border.png",
			"./bottom_right_border.png",
			"./middle_left_border.png",
			"./middle_middle_border.png",
			"./middle_right_border.png",
			"./top_left_border.png",
			"./top_middle_border.png",
			"./top_right_border.png",
			"./button_top_left.png",
			"./button_top_middle.png",
			"./button_top_right.png",
			"./button_middle_left.png",
			"./button_middle_middle.png",
			"./button_middle_right.png",
			"./button_bottom_left.png",
			"./button_bottom_middle.png",
			"./button_bottom_right.png",
			"./button_top_left_down.png",
			"./button_top_middle_down.png",
			"./button_top_right_down.png",
			"./button_middle_left_down.png",
			"./button_middle_middle_down.png",
			"./button_middle_right_down.png",
			"./button_bottom_left_down.png",
			"./button_bottom_middle_down.png",
			"./button_bottom_right_down.png",
			"./Blocktopia_12pt.fnt",
			"./Blocktopia_32pt.fnt"
		]
	},
	"default": {
		"scale": 1,
		"bg": "",
		"padding": 0,
		"bgPadding": 0,
		"corner": "./top_left_border.png",
		"line": "./top_middle_border.png",
		"font": {
			"size": "12px",
			"family": "Blocktopia_12pt",
			"color": "#f0f0f0"
		}
	},
	"Window": {
		"bgPadding": 6,
		"bg": "./middle_middle_border.png",
		"corner-tl": "./top_left_border.png",
		"corner-tr": "./top_right_border.png",
		"corner-bl": "./bottom_left_border.png",
		"corner-br": "./bottom_right_border.png",
		"line-t": "./top_middle_border.png",
		"line-r": "./middle_right_border.png",
		"line-b": "./bottom_middle_border.png",
		"line-l": "./middle_left_border.png"
	},
	"Button": {
		"bgPadding": 6,
		"bg": {
			"default": "./button_middle_middle.png",
			"down": "button_middle_middle_down.png"
		},
		"corner-tl": {
			"default": "./button_top_left.png",
			"down": "button_top_left_down.png"
		},
		"corner-tr": {
			"default": "./button_top_right.png",
			"down": "button_top_right_down.png"
		},
		"corner-bl": {
			"default": "./button_bottom_left.png",
			"down": "button_bottom_left_down.png"
		},
		"corner-br": {
			"default": "./button_bottom_right.png",
			"down": "button_bottom_right_down.png"
		},
		"line-t": {
			"default": "./button_top_middle.png",
			"down": "button_top_middle_down.png"
		},
		"line-r": {
			"default": "./button_middle_right.png",
			"down": "button_middle_right_down.png"
		},
		"line-b": {
			"default": "./button_bottom_middle.png",
			"down": "button_bottom_middle_down.png"
		},
		"line-l": {
			"default": "./button_middle_left.png",
			"down": "button_middle_left_down.png"
		}
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ./assets/ui/theme.json
 ** module id = 23
 ** module chunks = 0
 **/